export function counterHandler(val) {
    this.$emit('isCountdownActive', val);
}

export function getIsCheckAnswersButtonAvailableComputed(counterStopValue) {
    return function() {
        return !this.isGamePaused && this.counter === counterStopValue && this.stopGame && this.correct === null;
    };
}

export function getIsCheckAnswersButtonAvailableWatcher({
    emitCheckAnswersReadyEvent = false,
    triggerCounterHandler = false,
}) {
    return function(val) {
        if (emitCheckAnswersReadyEvent) {
            this.$emit('checkAnswersReady', { status: val, playerPosition: this.place });
        }
        if (triggerCounterHandler) {
            counterHandler.call(this, false);
        }
    };
}
